import { ReactElement } from "react";
import { AuthState, User, UserType } from "../utils/api/user/user.type";
import { useAppSelector } from "../redux/hook";
import { Navigate, useLocation, useSearchParams } from "react-router-dom";
// import { FieldType } from "../utils/constante";

export function isSuperAdmin(user?: User) {
  return user && user.userType === "superadmin";
}

export const isAdmin = (user: User) => {
  return (
    user?.userType === "admin" ||
    user?.userType === "superadmin"
  );
};

export function isStudent(user?: User) {
  return user && user.userType === "student";
}

export function isSchool(user?: User) {
  return user && user.userType === "school";
}

export function isParent(user?: User) {
  return user && user.userType === "parent";
}

export function isTeacher(user?: User) {
  return user && (user.userType === "teacher" || user.userType === "independentTeacher");
}

export function isIndependentTeacher(user?: User) {
  return user && user.userType === "independentTeacher";
}

export function isSchoolTeacher(user?: User) {
  return user && user.userType === "teacher";
}

export const RedirectAuthRoute = ({ children }: { children: ReactElement }) => {
  const { token, user } = useAppSelector(
    (state: { auth: AuthState }) => state.auth
  );
  const [params] = useSearchParams();
  let next = params.get("next");
  let path: string = "/connexion";
  if (isAdmin(user)) {
    path = next || "/admin/tableau-de-bord";
  }

  if (isSchool(user)) {
    path = next || "/etablissement/tableau-de-bord";
  }

  if (isStudent(user)) {
    path = next || "/eleve/tableau-de-bord";
  }

  if (isTeacher(user)) {
    path = next || "/professeur/tableau-de-bord";
  }

  if (isParent(user)) {
    path = next || "/parent/tableau-de-bord";
  }

  return !token && !user?.uid ? children : <Navigate to={path} replace />;
};

export const IsAdminAllow = ({ children }: { children: ReactElement }) => {
  const { user, token } = useAppSelector(
    (state: { auth: AuthState }) => state.auth
  );
  const location = useLocation();
  const [params] = useSearchParams();
  let next = params.get("next");
  let path: string = params.get("next") || `/connexion?next=${location.pathname}`;

  if (token) {
    if (isSchool(user)) {
      path = next || "/etablissement/tableau-de-bord";
    }
  
    if (isStudent(user)) {
      path = next || "/eleve/tableau-de-bord";
    }
  
    if (isTeacher(user)) {
      path = next || "/professeur/tableau-de-bord";
    }
  
    if (isParent(user)) {
      path = next || "/parent/tableau-de-bord";
      // path = next || "/parent/lier-un-compte/invitation-recue";
    }
  }
  
  return !token || !isAdmin(user) || next ? (
    <Navigate to={path} replace />
  ) : (
    children
  );
};

export const IsSchoolAllow = ({ children }: { children: ReactElement }) => {
  const { user, token } = useAppSelector(
    (state: { auth: AuthState }) => state.auth
  );
  const location = useLocation();
  const [params] = useSearchParams();
  let next = params.get("next");
  let path: string = params.get("next") || `/connexion?next=${location.pathname}`;

  if (token) {
    if (isAdmin(user)) {
      path = next || "/admin/tableau-de-bord";
    }
  
    if (isStudent(user)) {
      path = next || "/eleve/tableau-de-bord";
    }
  
    if (isTeacher(user)) {
      path = next || "/professeur/tableau-de-bord";
    }
  
    if (isParent(user)) {
      path = next || "/parent/tableau-de-bord";
    }
  }
  
  return !token || !isSchool(user) || next ? (
    <Navigate to={path} replace />
  ) : (
    children
  );
};

export const IsStudentAllow = ({ children }: { children: ReactElement }) => {
  const { user, token } = useAppSelector(
    (state: { auth: AuthState }) => state.auth
  );
  const location = useLocation();
  const [params] = useSearchParams();
  let next = params.get("next");
  let path: string = params.get("next") || `/connexion?next=${location.pathname}`;

  if (token) {
    if (isAdmin(user)) {
      path = next || "/admin/tableau-de-bord";
    }
  
    if (isSchool(user)) {
      path = next || "/etablissement/tableau-de-bord";
    }
  
    if (isTeacher(user)) {
      path = next || "/professeur/tableau-de-bord";
    }
  
    if (isParent(user)) {
      path = next || "/parent/tableau-de-bord";
    }
  }
  
  return !token || !isStudent(user) || next ? (
    <Navigate to={path} replace />
  ) : (
    children
  );
};

export const IsTeacherAllow = ({ children }: { children: ReactElement }) => {
  const { user, token } = useAppSelector(
    (state: { auth: AuthState }) => state.auth
  );
  const location = useLocation();
  const [params] = useSearchParams();
  let next = params.get("next");
  let path: string = params.get("next") || `/connexion?next=${location.pathname}`;

  if (token) {
    if (isAdmin(user)) {
      path = next || "/admin/tableau-de-bord";
    }
  
    if (isSchool(user)) {
      path = next || "/etablissement/tableau-de-bord";
    }
  
    if (isStudent(user)) {
      path = next || "/eleve/tableau-de-bord";
    }
  
    if (isParent(user)) {
      path = next || "/parent/tableau-de-bord";
      // path = next || "/parent/lier-un-compte/invitation-recue";
    }
  }
  
  return !token || !isTeacher(user) || next ? (
    <Navigate to={path} replace />
  ) : (
    children
  );
}

export const IsParentAllow = ({ children }: { children: ReactElement }) => {
  const { user, token } = useAppSelector(
    (state: { auth: AuthState }) => state.auth
  );
  const location = useLocation();
  const [params] = useSearchParams();
  let next = params.get("next");
  let path: string = params.get("next") || `/connexion?next=${location.pathname}`;

  if (token) {
    if (isAdmin(user)) {
      path = next || "/admin/tableau-de-bord";
    }
  
    if (isSchool(user)) {
      path = next || "/etablissement/tableau-de-bord";
    }
  
    if (isStudent(user)) {
      path = next || "/eleve/tableau-de-bord";
    }
  
    if (isTeacher(user)) {
      path = next || "/professeur/tableau-de-bord";
    }
  }
  
  return !token || !isParent(user) || next ? (
    <Navigate to={path} replace />
  ) : (
    children
  );
}

export const ProtectedRoutes = ({
  children,
  userType,
}: {
  children: ReactElement;
  userType: UserType[];
}) => {
  let location = useLocation();
  const { user } = useAppSelector((state) => state.auth);
  
  const isAccess = userType?.includes(user?.user_type);
  const auth = user?.id;
  return isAccess && isAccess !== undefined ? (
    children
  ) : auth && auth !== undefined ? (
    <Navigate to="/connexion" replace />
  ) : (
    <Navigate to="/" state={{ from: location }} replace />
  );
};
